import React, { Component } from "react";
import "./Splash.css";
import { Redirect } from "react-router-dom";
import LoaderLogo from "../../components/Loader/LoaderLogo.js";

function AnimatedSplash(props) {
  return (
    <div className="logo_wrapper">
      <div className="screen">
        <div className="puff-in-center initial">
          <div className="hi">Hi,</div>
          <div className="hi">Welcome Aboard 🖐</div>
        </div>
      </div>
    </div>
  );
}

class Splash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  componentDidMount() {
    this.id = setTimeout(() => this.setState({ redirect: true }), 6000);
    if (document.getElementById('con')) {
      document.getElementById('con').style.display = 'none';
    }
  }

  componentWillMount() {
    clearTimeout(this.id);
  }

  componentWillUnmount() {
    document.getElementById('con').style.display = 'flex';
  }

  render() {
    return this.state.redirect ? <Redirect to="/home" /> : <AnimatedSplash theme={this.props.theme} />;
  }
}

export default Splash;
